import main from "./main"

main().catch(console.error)
